var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "请添加需识别访客的站点地址",
        visible: _vm.dialogVisible,
        width: "350px",
        "before-close": _vm.handleClose,
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "box" },
        [
          _c(
            "el-form",
            { attrs: { model: _vm.form, size: "small" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "站点名称", "label-width": "66px" } },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: "请添加站点或网页命名",
                      autocomplete: "off",
                    },
                    model: {
                      value: _vm.form.siteName,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "siteName", $$v)
                      },
                      expression: "form.siteName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "站点地址", "label-width": "66px" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入网址", autocomplete: "off" },
                    model: {
                      value: _vm.form.mainUrl,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "mainUrl", $$v)
                      },
                      expression: "form.mainUrl",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              attrs: { type: "dialog-cancel", size: "small", w88: "" },
              on: {
                click: function ($event) {
                  _vm.dialogVisible = false
                },
              },
            },
            [_vm._v("取消")]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "dialog-confirm", size: "small", w88: "" },
              on: { click: _vm.saveOrUpdateSite },
            },
            [_vm._v("保存")]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }